export default {
      id: "ic_shoe-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#ic_shoe-usage",
      toString: function () {
        return this.url;
      }
    }